import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Spinner,
  Input,
  Label,
  Form,
  CardTitle,
  Table,
  Tooltip,
  Alert,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  FormGroup,
} from "reactstrap"
import { useFormik } from "formik"
import * as Yup from "yup" // For validation schema
import Select from "react-select"
import { useSelector, connect } from "react-redux"
import { setBreadcrumbItems } from "../../store/actions"
import { useNavigate } from "react-router-dom"
import config from "config/config"
import axios from "axios"
import SnackbarComponent from "components/SnackBar"

const CreateNewSurveyCampaign = props => {
  const navigate = useNavigate()
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )
  const userData = useSelector(state => state.Login.userData)

  const [loading, setLoading] = useState(false)
  const [isTemplateModalOpen, setIsTemplateModalOpen] = useState(false)

  const toggleTemplateModal = () => {
    setIsTemplateModalOpen(prev => !prev)
  }

  const [campaign, setCampaign] = useState(null)
  const [categories, setCategories] = useState([])
  const [audience, setAudience] = useState([])
  const [selectedCategories, setSelectedCategories] = useState([])
  const [newCategories, setNewCategories] = useState([])
  const [templates, setTemplates] = useState([])
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const [err, setErr] = useState(null)
  const [success, setSuccess] = useState(null)
  const [visible, setVisible] = useState(true)
  const [mostAvailedServices, setMostAvailedServices] = useState({})
  const [customers, setCustomers] = useState([])
  const [selectedCustomers, setSelectedCustomers] = useState([])
  const [audienceModalOpen, setAudienceModalOpen] = useState(false)

  const [formData, setFormData] = useState({
    organizationId: activeOrganization.id,
    survey: [],
    campaign: {
      cycle: "",
      frequency: "",
      campaignTitle: "",
      campaignDescription: "",
      startDate: "",
      endDate: "",
      audiences: [],
    },
  })
  // {
  //   organizationId: activeOrganization.id,
  //   title: "",
  //   description: "",
  //   campaign: {
  //     cycle: "",
  //     frequency: "",
  //     campaignTitle: "",
  //     campaignDescription: "",
  //     startDate: "",
  //     endDate: "",
  //   },
  //   audiences: [],
  //   oldCategories: [],
  //   newCategories: [],
  // },

  return <></>
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps, { setBreadcrumbItems })(
  CreateNewSurveyCampaign,
)
